
import { useEffect, useMemo, useState } from "react";
import axios from 'axios';
import { useToast } from './useToast';

import { getJobCategories, sleep } from "../Javascript_Functions_to_export/Utils";

const useFetch = (url) => {

    // *************   Used only in the Search.js component   *************
    // ********************************************************************

    
    
    //console.log("Inside useEffect hook");
    //debugger;

    //The code inside your custom Hooks will re-run during every re-render of your component,
    // like the 3 lines below.
    const [isLoading, setIsLoading] = useState(true);
    const [lsData, setLsData] = useState([]);
    const [lsPinnedJobs, setLsPinnedJobs] = useState([]);
    const [itemsNb, setItemsNb] = useState(-1);
    const toast = useToast();
    

    //console.log("useFetch hook was rendered");
    
    // but the debugger will not touch the useEffect hook, because the url did not change
    
    
    const getData = async () => {  // it will not be called, unless we write "getData()";
    //const getData = () => {  // it will not be called, unless we write "getData()";
    
        // the final conclusion : 
        // If the url did not change, the hook itself will render,
        // but the "useEffect" hook will not render, because the URL string still the same, ("aka   }, [url]   ") 
        
        setIsLoading(true);
        //console.log("url = ", url);
        //console.log("getting new data in 'useFetch hook' = ");
        //'https://restcountries.com/v3.1/all'

        const response = await fetch(url);  // we should await (c.a.d wait the response from the server)
        //const response = axios.get(url);  // we should await (c.a.d wait the response from the server)
        
        //sleep(4000);
        if(response.ok) { // "ok" : should be small letters, otherwise it will occured an exception
            //await waitToFetch();
            //console.log("Fetched");

            return response.json();
            //return response;
        }
        else {
            throw new Error("Data could not be fetched");
        }
        
        /*
        //'https://randomuser.me/api/?results=2'
        const { response } = await fetch(url);

        if(response) {
            return response;
        }
        else {
            throw new Error("Data could not be fetched");
        }*/
    }
    
    useEffect(() => {
        // useEffect : Runs on every render, if there is not an empty square brakets
        //try{
            if(!url)
                return;
            
            getData()
            .then((res) => {
                
                // console.log("views=", res.views, "expire= ", res.expire);
                // if(res && res.sessionEnded && res.sessionEnded === true) {
                //     console.log("sessionEnded=", res.sessionEnded, "expire=", res.expire);
                //     console.log("should logout");
                //     alert("Session has expired.")
                //     if(localStorag.getItem('Logo'))
                //         localStorag.removeItem('Logo');
                //     window.location.href = process.env.REACT_APP_ORIGI + "/login";
                // }

                //console.log("missing params", res.status);
                
                if(res.status && res.status === "failed") {
                    if(res.message)
                        toast("warning", res.message);
                        return { lsData: null, isLoading: false, itemsNb: 0 };
                }

                // ********   For "Pinned jobs" start  ****************
                var nowOnMillis = new Date().getTime();
                //debugger;
                // Recheck the featuring status
                res.forEach(job => {
                    if(job.Pinned === 1) {
                        var millisDiff = nowOnMillis - new Date(new Date(job.PostingDate).toLocaleString()).getTime();
                        //var daysDiff = millisDiff / 1000 / 3600 / 24;
                        if(millisDiff >= job.PinnedDays * 24 * 3600 * 1000) { // Pinned jobs still 5 days Pinned.
                            job.Pinned = 0;
                        }
                        //console.log(hoursDiff + " days"); // give the difference in hours
                    }
                    //console.log(res.length)
                });

                /*
                // Order the list by "Pinned" desc, then by "Date Time";
                res.sort((a, b) => b.Pinned - a.Pinned || 
                            new Date(b.PostingDate).getTime() - new Date(a.PostingDate).getTime());
                */
                // ********   For "Pinned jobs" end  ****************
                
                
                
                // new code start
                //debugger;
                var unpinnedJobs = res.filter(s => parseInt(s.Pinned) === 0);
                //debugger;
                //console.log(res);
                setLsData(unpinnedJobs);
                
                var pinnedJobs = res.filter(
                    s => parseInt(s.Pinned) === 1 && 
                    nowOnMillis - new Date(new Date(s.PostingDate).toLocaleString()).getTime() 
                    <= s.PinnedDays * 24 * 60 * 60 * 1000)

                setLsPinnedJobs(pinnedJobs); // 5 days
                // new code end

                if(res) { // old
                    setItemsNb(res.length); // old line code
                }
            })
            .catch((error) => {console.log("1error = ", error);})
            .finally(() => {
                setIsLoading(false);
            });

            //console.log("data not fetched yet");

        // }
        //  catch (error) {
        //      console.log("err = ", error);
        //     }
        // finally{
        //      setIsLoading(false);
        //      console.log("finally block | setting isLoading = false");
        //  }

        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, [url]);

    return { lsData, isLoading, itemsNb, lsPinnedJobs };
    //return lsData;
}

export default useFetch;









